<template lang="pug">
  form(@submit.prevent="filterEvent")
    div.form-group(v-show="showDate")
      div.form-group
        label 開始時間
        input.form-control.form-control-sm(type="date" v-model="startDate")
      div.form-group
        label 結束時間
        input.form-control.form-control-sm(type="date" v-model="endDate")
    div.form-group(v-show="showStartDate")
      div.form-group
        label 查詢日期
        input.form-control.form-control-sm(type="date" v-model="startDate")
    input.btn.btn-primary.mb-2.w-100(@click="filterEvent" type="submit" v-show="showFilterButton" value="查詢")
    button.btn.btn-info.mb-2.w-100(@click="getReport" v-show="showReportButton") 下載報告
</template>

<script>
import moment from 'moment';

export default {
  name: 'QueryFilter',
  props: {
    showDate: {
      type: Boolean,
      default: true,
    },
    showStartDate: {
      type: Boolean,
      default: false,
    },
    showEventType: {
      type: Boolean,
      default: true,
    },
    showSystem: {
      type: Boolean,
      default: true,
    },
    showFilterButton: {
      type: Boolean,
      default: true,
    },
    showReportButton: {
      type: Boolean,
      default: true,
    },
    showMedRecordNum: {
      type: Boolean,
      default: false,
    },
    showMedication: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      startDate: moment().format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
      selectType: [],
      selectSystem: undefined,
      eventTable: [],
      moreParams: {},
      systems: [],
      searchDrug: '',
      searchMedicines: [],
      medicineSelected: {},
      medRecordNum: '',
    };
  },
  created() {
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
  },
  methods: {
    emitFilterParams(val) {
      if (this.startDate !== undefined) {
        this.moreParams.start_date = this.startDate;
      } else {
        delete this.moreParams.start_date;
      }
      if (this.endDate !== undefined) {
        this.moreParams.end_date = this.endDate;
      } else {
        delete this.moreParams.end_date;
      }
      this.$emit(val, this.moreParams);
    },
    filterEvent() {
      this.emitFilterParams('filter');
    },
    getReport() {
      this.emitFilterParams('report');
    },
  },
  watch: {
    startDate(val) {
      if (val > this.endDate && this.endDate !== '') {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '開始時間不可晚於結束時間',
        });
        this.startDate = this.endDate;
      }
    },
    endDate(val) {
      if (val < this.startDate && this.startDate !== '') {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '結束時間不可早於開始時間',
        });
        this.endDate = this.startDate;
      }
    },
  },
};
</script>

<style lang="sass">
.with-med-search
  position: relative
.med-option-wrapper
  position: absolute
  top: 63px
  right: 0px
  z-index: 100;
  width: 200%;
  float: right;
  background-color: white;
  border: 1px solid rgba(0, 0, 0, 0.3);
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
  .med-option
    padding: 1px 5px
    font-size: 14px
    color: steelblue
    &:hover
      background-color: steelblue
      color: white

.event-type-wrapper
  height: 300px;
  overflow-y: scroll;
  border: 1px solid #ced4da;
  border-radius: 3px;
  padding: 0px 5px;
</style>



// WEBPACK FOOTER //
// QueryFilter.vue?a9d6d736